var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%","min-height":"100%"}},[_c('div',{staticClass:"g-recaptcha",attrs:{"data-sitekey":_vm.gKey,"id":"recaptcha-div"}})])}
var staticRenderFns = []

export { render, staticRenderFns }